import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button, Spinner } from "reactstrap";
import { PostData } from "../../../services/FetchData";
import Cookies from "js-cookie";

const AcceptInvite = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const token = searchParams.get("token");
	const [status, setStatus] = useState("loading"); // loading | success | error
	const [message, setMessage] = useState("");

	useEffect(() => {
		if (!token) {
			setStatus("error");
			setMessage("Invalid invitation link.");
			return;
		}
		PostData("ms1", "api/v1/organization/accept-invite", { token }, false, false)
			.then((res) => {
				if (res && res.status === "success") {
					setStatus("success");
					setMessage(res.message || "You have joined the team.");
					// If user was created or already logged in, they may have a token; redirect to dashboard after short delay
					if (Cookies.get("_cb_search_token")) {
						setTimeout(() => navigate("/user/dashboard", { replace: true }), 2000);
					} else {
						setTimeout(() => navigate("/auth/login", { replace: true }), 3000);
					}
				} else {
					setStatus("error");
					setMessage(res?.message || "Invalid or expired invitation.");
				}
			})
			.catch(() => {
				setStatus("error");
				setMessage("Something went wrong. The invitation may have expired.");
			});
	}, [token, navigate]);

	return (
		<div className="authFormContainer">
			<div className="authFormInnerWrapper">
				{status === "loading" && (
					<>
						<p>Accepting invitation…</p>
						<Spinner />
					</>
				)}
				{status === "success" && (
					<>
						<h5 className="text-success">Success</h5>
						<p>{message}</p>
						<p className="small text-muted">Redirecting you…</p>
						<Button color="primary" onClick={() => navigate(Cookies.get("_cb_search_token") ? "/user/dashboard" : "/auth/login", { replace: true })}>
							Go now
						</Button>
					</>
				)}
				{status === "error" && (
					<>
						<h5 className="text-danger">Invalid invitation</h5>
						<p>{message}</p>
						<Button color="primary" onClick={() => navigate("/auth/login", { replace: true })}>
							Go to login
						</Button>
					</>
				)}
			</div>
		</div>
	);
};

export default AcceptInvite;
